<div
  class="grid justify-content-end grid-nogutter pt-top-banner"
  [class.pt-top-banner--sticky]="sticky"
>
  <div class="lg:col-2 md:col-4 col-nogutter">
    <a class="pt-top-banner__link" href="tel:+43507441000">
      <i class="pi pi-mobile"></i>
      <span>+43 (0) 50744 - 1000</span>
    </a>
  </div>
  <div class="lg:col-2 md:col-4 col-nogutter">
    <a class="pt-top-banner__link" href="mailto:office@transgourmet.at">
      <i class="pi pi-envelope"></i>
      <span>office&#64;transgourmet.at</span>
    </a>
  </div>
</div>
